import request from './request'

export async function getCurrentCityName () {
  try {
    const params = { output: 'json', key: '69d54442577598efae315e455bf7e8c5' }
    const resp = await request.get('https://restapi.amap.com/v3/ip', { params })
    if (resp) {
      if (resp.status === '1' && resp.info === 'OK') {
        return resp.city.replace('市', '')
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
  }
}
